import { Text, View } from '@react-pdf/renderer';
import { TableFooterStyle } from '../../../styles';
import convertNumberToWords, {
  footerRowCss,
  footerRowCssDescription,
} from '../../../utils/Level/utils';

const borderColor = 'green';

const styles = TableFooterStyle;

const LedgerTableFooter = ({
  items,
  totalDebit,
  totalCredit,
  balance,
  codeDetails,
}) => {
  // const total = items
  //   .map((item) => item.qty * item.rate)
  //   .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  return (
    <View>
      <View style={footerRowCss}>
        <Text style={styles.description}>TOTAL</Text>
        {/* <Text style={styles.total}>{ Number.parseFloat(total).toFixed(2)}</Text> */}
        <Text style={styles.bottomSpace}></Text>
        <Text style={styles.total}>{totalDebit}</Text>
        <Text style={styles.total}>{totalCredit}</Text>
        <Text style={styles.total}>{balance}</Text>
      </View>
      <View style={footerRowCss}>
        <Text style={footerRowCssDescription}>
          {codeDetails.codeLevel3} {codeDetails.descLevel3}
        </Text>
        <Text style={styles.bottomSpace}></Text>
        {/* <Text style={styles.total}>{ Number.parseFloat(total).toFixed(2)}</Text> */}
        <Text style={styles.totalBottom}>{totalDebit}</Text>
        <Text style={styles.totalBottom}>{totalCredit}</Text>
        <Text style={styles.totalBottom}>{balance}</Text>
      </View>
    </View>
  );
};
export const CashBookTableFooter = ({ items }) => {
  // const total = items
  //   .map((item) => item.qty * item.rate)
  //   .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  return (
    <View>
      <View style={[footerRowCss, { marginTop: 2, borderWidth: 1 }]}>
        <Text style={styles.cashBookColSmall}> </Text>
        <Text style={styles.cashBookColSmall}> </Text>
        <Text style={styles.cashBookColCode}> </Text>
        <Text
          style={[styles.cashBookPar, { color: 'red', textAlign: 'center' }]}
        >
          Total
        </Text>
        <View style={[styles.cashBookRec]}>
        <View style={{ flexDirection: 'row' }}>
            <View style={styles.cashBookColSub}>
              <Text>{(parseInt(items.headerData.cashReceived+"")).toLocaleString()}</Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>{items.headerData.bankReceived.toLocaleString()}</Text>
            </View>
            {/* <View style={styles.cashBookColSub}>
              <Text>{items.headerData.salePaid.toLocaleString()}</Text>
            </View> */}
            <View style={[styles.cashBookColSub]}>
              <Text>{items.headerData.journalReceived.toLocaleString()}</Text>
            </View>
          </View>
         
        </View>
        <View style={[styles.cashBookRec]}>
        <View style={{ flexDirection: 'row' }}>
            <View style={styles.cashBookColSub}>
              <Text>{(items.headerData.cashPaid).toLocaleString()}</Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>{items.headerData.bankPaid.toLocaleString()}</Text>
            </View>
             {/* <View style={[styles.cashBookColSub]}>
              <Text>{items.headerData.saleReceived.toLocaleString()}</Text>
            </View> */}
            <View style={styles.cashBookColSub}>
              <Text>{items.headerData.journalPaid.toLocaleString()}</Text>
            </View>
          </View>
        </View>
        <View
          style={[styles.cashBookRec, { width: "6%", borderRightWidth: 0 }]}
        >
          <View style={[styles.cashBookColSub,{ width: "100%", borderRightWidth: 0 }]}>
          <Text>{items.headerData.saleReceived.toLocaleString()}</Text>

          </View>
        </View>
      </View>
      <View
        style={[
          footerRowCss,
          { marginTop: 0, borderWidth: 1, borderTopWidth: 0 },
        ]}
      >
        <Text style={styles.cashBookColSmall}> </Text>
        <Text style={styles.cashBookColSmall}> </Text>
        <Text style={styles.cashBookColCode}> </Text>
        <Text
          style={[styles.cashBookPar, { color: 'red', textAlign: 'center' }]}
        >
          Total cash in hand
        </Text>
        <View style={styles.cashBookRec}>
          <View style={{ flexDirection: 'row' }}>
            <View style={styles.cashBookColSub}>
              <Text>
                {styles.cashBookData}{' '}
                {(
                  items.headerData.cashOpenningBalance +
                  items.headerData.cashReceived -
                  items.headerData.cashPaid
                ).toLocaleString()}
              </Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text>
                {(
                  items.headerData.bankOpenningBalance +
                  items.headerData.bankReceived -
                  items.headerData.bankPaid
                ).toLocaleString()}
              </Text>
            </View>
            {/* <View style={[styles.cashBookColSub, { borderRightWidth: 0 }]}>
              <Text> </Text>
            </View> */}
            <View style={[styles.cashBookColSub]}>
              <Text> </Text>
            </View>
          </View>
        </View>
        <View style={styles.cashBookRec}>
          <View style={{ flexDirection: 'row' }}>
            <View style={styles.cashBookColSub}>
              <Text> </Text>
            </View>
            <View style={styles.cashBookColSub}>
              <Text> </Text>
            </View>
            {/* <View style={styles.cashBookColSub}>
              <Text> </Text>
            </View> */}
            <View style={[styles.cashBookColSub]}>
              <Text> </Text>
            </View>
          </View>
        </View>
        <View
          style={[styles.cashBookRec, { width: "6%", borderRightWidth: 0 }]}
        >
          <View style={[styles.cashBookColSub,{ width: "100%", borderRightWidth: 0 }]}>
            <Text>
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export const VoucherTableFooter = ({ totalDebit, totalCredit }) => {
  return (
    <View>
      <View style={styles.footerVoucherCss}>
        <Text style={styles.voucherFooterAmountinText}>
          {convertNumberToWords(totalCredit)}
        </Text>
        <Text style={styles.voucherdescription}>TOTAL:</Text>
        {/* <Text style={styles.total}>{ Number.parseFloat(total).toFixed(2)}</Text> */}
        <Text style={styles.totalVocuher}></Text>
        <Text style={styles.totalVocuher}>{totalDebit}</Text>
        <Text style={styles.totalVocuher}>{totalCredit}</Text>
      </View>

      <View style={styles.footerVoucherSignatureArea}>
        <Text style={{ borderTopWidth: 1, alignItems: 'center' }}>
          {' '}
          Prepared By{' '}
        </Text>
        <Text style={{ borderTopWidth: 1 }}> Checked By </Text>
        <Text style={{ borderTopWidth: 1 }}> Approved By </Text>
        <Text style={{ borderTopWidth: 1 }}> Received By </Text>
      </View>
    </View>
  );
};

export default LedgerTableFooter;
